module.exports = __webpack_public_path__ + "static/media/thumb.3c3b0ba7.jpg";